<template>
    <div>
        <h3 class="title">Help improve our service</h3>
        <p>How did you like our service?</p>
        <Rating @like_rate="saveLikeRate"/>
        <br/>
        <p>How likely are you to recommend our service to a friend or a colleague?</p>
        <RangeSlider @recommendation_rate="saveRecommendationRate"/>
        <br/>
        <p>Any thoughts on how to improve our service?</p>
        <textarea 
          v-model="comment" 
          placeholder="Tell us what you think?" 
          rows="20" 
          name="comment[text]" 
          id="comment_text" 
          cols="40" 
          class="ui-autocomplete-input" 
          autocomplete="off" 
          role="textbox" 
          aria-autocomplete="list" 
          aria-haspopup="true"
          @blur="$v.comment.$touch()">
        </textarea>
        <br/>
        <button class="secondary-gradient cta-button pulse" type="button" @click="saveServiceReviewDetails">SUBMIT</button>
        <sweet-modal id="serviceReview-success" icon="success" ref="modalSuccess" name="successModal" @close="$bvModal.hide('serviceReview-modal')">
            Thanks for your valuable response, it will help us to improve further!
        </sweet-modal>
    </div>
</template>

<script>

import Rating from '@/components/common/Rating.vue'
import RangeSlider from '@/components/common/RangeSlider.vue'
import { SweetModal } from 'sweet-modal-vue';
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
      Rating,
      RangeSlider,
      SweetModal
  },
    validations: {
    comment: { required }
  },
  data() {
    return {
      likeRate: 0,
      recommendationRate: 0,
      comment: ''
    }
  },
  methods: {
    saveLikeRate(response) {
      this.likeRate = response
    },
    saveRecommendationRate(response) {
      this.recommendationRate = response
    },
    async saveServiceReviewDetails() {
      await this.$store.dispatch('order/saveReviewDetails', {
        like_rate: +this.likeRate,
        recommendation_rate: +this.recommendationRate,
        comment: this.comment,
        product_id: this.productId
      })
      this.$refs.modalSuccess.open();
    }
  },
  props: {
    productId: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>

.title {
margin: 0.5em;
}

textarea {
  margin-top: 10px;
  width: 100%;
  height: 100px;
  -moz-border-bottom-colors: none;
  -moz-border-left-colors: none;
  -moz-border-right-colors: none;
  -moz-border-top-colors: none;
  background: none repeat scroll 0 0 rgba(0, 0, 0, 0.01);
  border-color: -moz-use-text-color #FFFFFF #FFFFFF -moz-use-text-color;
  border-image: none;
  border-radius: 6px 6px 6px 6px;
  border-style: none solid solid none;
  border-width: medium 1px 1px medium;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12) inset;
  color: #555555;
  font-size: 1em;
  line-height: 1.4em;
  padding: 5px 8px;
  transition: background-color 0.2s ease 0s;
}


textarea:focus {
    background: none repeat scroll 0 0 rgba(0, 0, 0, 0.07);
    outline-width: 0;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

.cta-button {
  background: linear-gradient(to right, #fb7377, #c95c5f);
  width: 45%;
  padding: 10px;
  color: white;
  margin-top: 5px 10px 50px 10px;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  border: none;
  border-radius: 5px;
  font-size: 1.4em;
  text-align: center;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s linear;
}

.cta-button:hover {
  transform: scale(1);
  box-shadow: none;
  background: linear-gradient(to right, #f7921ec9, #c46428a8);
}

.cta-button:active {
  animation: pulse 0.25s infinite ease-out;
}

.cta-button:focus {
  outline: 0;
}
.cta-button:disabled {
  -webkit-transform: scale(1);
  transform: scale(1);
  box-shadow: none;
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
  }
  40% {
    transform: scale(1);
  }
  80% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}

</style>